<template>
  <div>
    <div class="page-head">
      <div>
        <h3>BDbildeler Orders</h3>
        <p class="page-head-sub">Value of parts ordered on bdbildeler.no</p>
      </div>
    </div>
    <div class="toolbar">
      <div class="toolbar-field">
        <label>Start date</label>
        <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="fromDate" class="text-dark"></datepicker>
      </div>
      <div class="toolbar-field">
        <label>End date</label>
        <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="toDate" class="text-dark"></datepicker>
      </div>
      <button @click="fetchStats" :class="!fromDate || !toDate ? 'btn-secondary disabled' : 'btn-primary'" class="btn px-4">
        <b-icon-search class="mr-2"></b-icon-search>Search
      </button>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <div class="chart-card">
      <area-chart
        :colors="['#0a84ff']"
        :dataset="{borderWidth: 4}"
        :messages="{empty: 'Select date range to generate stats'}"
        :data="chartData">
      </area-chart>
    </div>

    <div v-if="totalForRange" class="stat-grid">
      <div class="stat-tile success">
        <p class="stat-label">Total value</p>
        <p class="stat-value">{{Math.round(totalForRange).toLocaleString('en')}} NOK</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import fixed from '../../fixed';

export default {
  name: 'WebStats',
  components: {
    Datepicker,
  },
  data: () => ({
    loading: false,
    chartData: {},
    fromDate: null,
    toDate: null,
    totalForRange: 0,
  }),
  async mounted() {
    this.toDate = new Date();
    this.fromDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), 1);
    await this.fetchStats();
  },
  methods: {
    async fetchStats() {
      if (!this.fromDate || !this.toDate) return;

      this.totalForRange = 0;
      this.loading = true;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/poland-stats?from=${moment(this.fromDate).format('yyyy-MM-DD')}&to=${moment(this.toDate).format('yyyy-MM-DD')}&web=true`,
          { withCredentials: true },
        );
        this.chartData = data.reduce((acc, curr) => {
          const date = curr._id.split('T')[0]; // eslint-disable-line

          if (acc[date]) {
            acc[date] = (parseFloat(acc[date]) + curr.ordered).toFixed(2);
          } else {
            acc[date] = curr.ordered.toFixed(2);
          }

          this.totalForRange += curr.ordered;
          return acc;
        }, {});
      } catch (error) {
        this.chartData = {};
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻');
        } else {
          this.$toast.info('No data for selected range');
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>

</style>
